import { createContext, useContext } from "react";

// Quem guarda os dados da empresa ativa (nome, cores, logos, parâmetros) é o Layout,
// lidos do /me. A tela que os altera avisa por aqui, e a casca muda sem recarregar.
export const CompanyDataContext = createContext(() => {});

/** `update(companyData)`: os campos novos da empresa ativa, mesclados nos atuais. */
export function useUpdateCompanyData() {
  return useContext(CompanyDataContext);
}
